import { Card, CardContent } from "@/components/ui/card";
import { Star } from "lucide-react";
import StructuredData from "@/components/seo/StructuredData";

const ReviewsSection = () => {
  const reviews = [
    {
      author: "Marie L.",
      company: "Pharmacie du Centre",
      rating: 5,
      date: "2024-11-15",
      text: "Service impeccable pour le nettoyage de notre pharmacie. Équipe professionnelle et respectueuse des horaires. Nos vitrines n'ont jamais été aussi propres !"
    },
    {
      author: "Thomas B.",
      company: "Bureau d'Études TechNantes",
      rating: 5,
      date: "2024-10-22",
      text: "EPP assure l'entretien de nos bureaux depuis 2 ans. Travail sérieux, ponctualité irréprochable. Je recommande vivement pour les entreprises nantaises."
    },
    {
      author: "Sophie D.",
      company: "Copropriété Les Jardins",
      rating: 5,
      date: "2024-09-08",
      text: "Excellent rapport qualité-prix pour le nettoyage de notre immeuble. Personnel compétent et à l'écoute. Très satisfaite de leurs prestations."
    },
    {
      author: "Alexandre M.",
      company: "Restaurant Le Vieux Port",
      rating: 5,
      date: "2024-12-03",
      text: "Intervention rapide et efficace pour le nettoyage de notre terrasse. Résultat impeccable, nos clients ont remarqué la différence. Merci EPP !"
    }
  ];

  const businessData = {
    "@type": "LocalBusiness",
    name: "EPP Espaces Paysages & Propreté",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "5.0",
      reviewCount: reviews.length,
      bestRating: "5",
      worstRating: "1"
    },
    review: reviews.map(review => ({
      "@type": "Review",
      author: {
        "@type": "Person",
        name: review.author
      },
      datePublished: review.date,
      reviewBody: review.text,
      reviewRating: {
        "@type": "Rating",
        ratingValue: review.rating.toString(),
        bestRating: "5",
        worstRating: "1"
      },
      itemReviewed: {
        "@type": "LocalBusiness",
        name: "EPP Espaces Paysages & Propreté",
        address: {
          "@type": "PostalAddress",
          addressLocality: "Nantes",
          addressCountry: "FR"
        }
      }
    }))
  };

  return (
    <section className="py-16">
      <StructuredData type="LocalBusiness" data={businessData} />
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Avis de Nos{" "}
            <span className="bg-gradient-primary bg-clip-text text-transparent">
              Clients
            </span>
          </h2>
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-6 w-6 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="text-lg font-semibold">5.0/5</span>
            <span className="text-muted-foreground">({reviews.length} avis)</span>
          </div>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Découvrez ce que nos clients à Nantes et dans toute la Loire-Atlantique pensent de nos services de nettoyage professionnel
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {reviews.map((review, index) => (
            <Card key={index} className="hover:shadow-lg transition-all">
              <CardContent className="pt-6">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="font-semibold text-lg">{review.author}</h3>
                    <p className="text-sm text-muted-foreground">{review.company}</p>
                  </div>
                  <div className="flex">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                </div>
                <p className="text-muted-foreground leading-relaxed italic">
                  "{review.text}"
                </p>
                <p className="text-xs text-muted-foreground mt-4">
                  {new Date(review.date).toLocaleDateString('fr-FR', { 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric' 
                  })}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
